import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Download, Eye, FileText, Loader2, X } from 'lucide-react';
import { toast } from 'sonner';
import { BACKEND_URL } from './constants';
import { getToken } from '../../services/tokenService';

export default function AttestationDraftButton({ adhesion }) {
  const [loading, setLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleDownload = async () => {
    setLoading(true);
    try {
      const token = getToken();
      // Utiliser le token en URL pour éviter le conflit avec les intercepteurs fetch (rrweb-recorder)
      // qui tentent de clone() la Response et crashent sur les blobs PDF
      const url = `${BACKEND_URL}/api/ftpe-adhesion/attestation/${adhesion.id}/download?token=${encodeURIComponent(token)}`;
      const a = document.createElement('a');
      a.href = url;
      a.download = `ATTESTATION_FTPE_${adhesion.raison_sociale || adhesion.id}.pdf`;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      toast.error(err.message || 'Erreur telechargement attestation');
    } finally {
      setLoading(false);
    }
  };

  const handlePreview = async () => {
    setLoading(true);
    try {
      const token = getToken();
      const url = `${BACKEND_URL}/api/ftpe-adhesion/attestation/${adhesion.id}/download?token=${encodeURIComponent(token)}&preview=true`;
      setPreviewUrl(url);
    } catch {
      toast.error('Erreur lors de la previsualisation');
    } finally {
      setLoading(false);
    }
  };

  const isActive = ['active', 'completed', 'signed'].includes(adhesion.status);

  if (!isActive) {
    return (
      <Badge variant="outline" className="text-gray-400 text-xs">
        <FileText className="w-3 h-3 mr-1" />
        Indisponible
      </Badge>
    );
  }

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="sm"
        onClick={handleDownload}
        disabled={loading}
        title="Telecharger l'attestation FTPE"
        className="text-blue-600 hover:text-blue-700 hover:bg-blue-50"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={handlePreview}
        disabled={loading}
        title="Previsualiser l'attestation"
        className="text-purple-600 hover:text-purple-700 hover:bg-purple-50"
      >
        <Eye className="w-4 h-4" />
      </Button>

      {previewUrl && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={() => { setPreviewUrl(null); URL.revokeObjectURL(previewUrl); }}>
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] flex flex-col" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between p-3 border-b">
              <span className="font-medium text-sm">Attestation FTPE - {adhesion.raison_sociale}</span>
              <Button variant="ghost" size="sm" onClick={() => { setPreviewUrl(null); URL.revokeObjectURL(previewUrl); }}>
                <X className="w-4 h-4" />
              </Button>
            </div>
            <iframe src={previewUrl} className="flex-1 min-h-[70vh]" title="Preview attestation" />
          </div>
        </div>
      )}
    </div>
  );
}
